export default "__VITE_ASSET__B037iTfc__"